import PropTypes from "prop-types";

import { Icon } from "../../../components/BaseComponents/Icon";

export const FilledCircleRightIcon = (props) => (
	<Icon viewBox="0 0 16 16" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 14A6 6 0 108 2a6 6 0 000 12zm-.496-8.46a.6.6 0 10-.768.92L8.583 8 6.736 9.54a.6.6 0 10.768.92l2.4-2a.6.6 0 000-.92l-2.4-2z"
			fill="currentColor"
		/>
	</Icon>
);

FilledCircleRightIcon.propTypes = {
	className: PropTypes.string,
};
